import { CardWrapper } from './styled';
import { CardImage } from './CardImage';
import { Author } from './Author';
import { ArticleDescription } from './ArticleDescription';
import { ArticleTitle } from './ArticleTitle';

type Props = {
  slug: string;
  title: string;
  excerpt: string | null;
  imageUrl: string | null;
  publishedDate: string;
  author?: string | null;
  authorAvatarUrl?: string | null;
  authorSlug?: string | null;
  index: number;
};
export const ArticleCard = ({
  title,
  author,
  authorAvatarUrl,
  authorSlug,
  imageUrl,
  excerpt,
  slug,
  publishedDate,
  index,
}: Props) => {
  return (
    <CardWrapper>
      {imageUrl && (
        <CardImage
          slug={slug}
          imageUrl={imageUrl}
          title={title}
          index={index}
        />
      )}
      <ArticleTitle title={title} slug={slug} index={index} />
      {excerpt && <ArticleDescription excerpt={excerpt} index={index} />}
      {author && authorSlug && authorAvatarUrl && (
        <Author
          author={author}
          authorSlug={authorSlug}
          authorAvatarUrl={authorAvatarUrl}
          publishedDate={publishedDate}
          index={index}
        />
      )}
    </CardWrapper>
  );
};
